import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'journey-detail-breadcrumbs';
const BLOCK_ID = 'journey-detail-breadcrumbs';
const PLACEHOLDER_LABEL = 'Brotkrumen';

export default function journeyDetailBreadcrumbs(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-journey-detail-breadcrumbs') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },
        model: {
            defaults: {
                tagName: 'div',
                name: 'Brotkrumen',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-breadcrumbs',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [{}],
            },
        },
        view: {},
    });
    blockManager.add(BLOCK_ID, {
        label: 'Brotkrumen',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6Zm-6 0L2.59 7.41 7.17 12l-4.58 4.59L4 18l6-6-6-6Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-breadcrumbs',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
